/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SchreibenRouteImport } from './routes/schreiben'
import { Route as RechnenRouteImport } from './routes/rechnen'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LehrerRouteImport } from './routes/lehrer'
import { Route as ArbeitsblattRouteImport } from './routes/arbeitsblatt'
import { Route as IndexRouteImport } from './routes/index'

const SchreibenRoute = SchreibenRouteImport.update({
  id: '/schreiben',
  path: '/schreiben',
  getParentRoute: () => rootRouteImport,
} as any)
const RechnenRoute = RechnenRouteImport.update({
  id: '/rechnen',
  path: '/rechnen',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LehrerRoute = LehrerRouteImport.update({
  id: '/lehrer',
  path: '/lehrer',
  getParentRoute: () => rootRouteImport,
} as any)
const ArbeitsblattRoute = ArbeitsblattRouteImport.update({
  id: '/arbeitsblatt',
  path: '/arbeitsblatt',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/arbeitsblatt': typeof ArbeitsblattRoute
  '/lehrer': typeof LehrerRoute
  '/login': typeof LoginRoute
  '/rechnen': typeof RechnenRoute
  '/schreiben': typeof SchreibenRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/arbeitsblatt': typeof ArbeitsblattRoute
  '/lehrer': typeof LehrerRoute
  '/login': typeof LoginRoute
  '/rechnen': typeof RechnenRoute
  '/schreiben': typeof SchreibenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/arbeitsblatt': typeof ArbeitsblattRoute
  '/lehrer': typeof LehrerRoute
  '/login': typeof LoginRoute
  '/rechnen': typeof RechnenRoute
  '/schreiben': typeof SchreibenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/arbeitsblatt'
    | '/lehrer'
    | '/login'
    | '/rechnen'
    | '/schreiben'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/arbeitsblatt' | '/lehrer' | '/login' | '/rechnen' | '/schreiben'
  id:
    | '__root__'
    | '/'
    | '/arbeitsblatt'
    | '/lehrer'
    | '/login'
    | '/rechnen'
    | '/schreiben'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArbeitsblattRoute: typeof ArbeitsblattRoute
  LehrerRoute: typeof LehrerRoute
  LoginRoute: typeof LoginRoute
  RechnenRoute: typeof RechnenRoute
  SchreibenRoute: typeof SchreibenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/schreiben': {
      id: '/schreiben'
      path: '/schreiben'
      fullPath: '/schreiben'
      preLoaderRoute: typeof SchreibenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/rechnen': {
      id: '/rechnen'
      path: '/rechnen'
      fullPath: '/rechnen'
      preLoaderRoute: typeof RechnenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/lehrer': {
      id: '/lehrer'
      path: '/lehrer'
      fullPath: '/lehrer'
      preLoaderRoute: typeof LehrerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arbeitsblatt': {
      id: '/arbeitsblatt'
      path: '/arbeitsblatt'
      fullPath: '/arbeitsblatt'
      preLoaderRoute: typeof ArbeitsblattRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArbeitsblattRoute: ArbeitsblattRoute,
  LehrerRoute: LehrerRoute,
  LoginRoute: LoginRoute,
  RechnenRoute: RechnenRoute,
  SchreibenRoute: SchreibenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
